import React = require('react');

export interface EditGroupSetDialogLabelStyleProps {
    message: string;
    style: React.CSSProperties;
}

export function EditGroupSetDialogLabel(props: EditGroupSetDialogLabelStyleProps): JSX.Element {
    return <div style={props.style}><span>{props.message}</span></div>;
}